import { NotificationDto, UpsertNotificationSubscriptionDto } from '@inosio/payments-sdk';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { createNotificationSubscription, deleteNotificationSubscription } from '../sagas/notificationSettingSlice';
import { Box, Checkbox, FormControlLabel, FormGroup, Grid, Switch, Typography } from '@mui/material';

interface ExtendedNotificationsDto extends NotificationDto {
  additionalOption?: NotificationDto; // any additional notification setting that is not a switch but a checkbox
}

export function NotificationTab(props: ExtendedNotificationsDto) {
  const dispatch = useDispatch();
  const [checked, setChecked] = useState(props.subscribed);
  const [additionalChecked, setAdditionalChecked] = useState(!!props.additionalOption?.subscribed);

  const handleChange = () => {
    const newState = !checked;
    setChecked(newState);

    //if checked then create a notification subscription otherwise delete it
    if (newState) {
      dispatch({
        type: createNotificationSubscription.type,
        payload: {
          notificationId: props.id,
        } as UpsertNotificationSubscriptionDto,
      });
      if (props.additionalOption) {
        setAdditionalChecked(newState);
        dispatch({
          type: createNotificationSubscription.type,
          payload: {
            notificationId: props.additionalOption?.id,
          } as UpsertNotificationSubscriptionDto,
        });
      }
    } else {
      dispatch({
        type: deleteNotificationSubscription.type,
        payload: {
          notificationId: props.id,
        },
      });
      if (props.additionalOption && additionalChecked) {
        setAdditionalChecked(newState);
        dispatch({
          type: deleteNotificationSubscription.type,
          payload: {
            notificationId: props.additionalOption?.id,
          },
        });
      }
    }
  };

  const handleAdditionalOptionChange = () => {
    const newState = !additionalChecked;
    setAdditionalChecked(newState);

    //if checked then create a notification subscription otherwise delete it
    if (newState) {
      dispatch({
        type: createNotificationSubscription.type,
        payload: {
          notificationId: props.additionalOption?.id,
        } as UpsertNotificationSubscriptionDto,
      });
    } else {
      dispatch({
        type: deleteNotificationSubscription.type,
        payload: {
          notificationId: props.additionalOption?.id,
        },
      });
    }
  };

  return (
    <Box sx={{ p: 2, pt: 4, pb: 4, borderTop: '2px solid #F1F0F5' }}>
      <Grid container>
        <Grid item xs={1}>
          <Switch checked={checked} onChange={handleChange} inputProps={{ 'aria-label': 'controlled' }} />
        </Grid>
        <Grid item xs={6} lg={4} sx={{ pt: '0.6%', pl: '1%', '.MuiTypography-root': { fontFamily: 'Work Sans, sans-serif' } }}>
          <Typography sx={{ fontWeight: '600' }}>{props.title}</Typography>
          <Typography sx={{ fontSize: '14px', marginBottom: '2%' }}>{props.frequency}</Typography>
          <Typography sx={{ fontSize: '15px' }}>{props.description}</Typography>
        </Grid>
        {props.additionalOption && (
          <Grid item xs={5} lg={7} sx={{ pt: '0.6%', pl: '1%', '.MuiTypography-root': { fontFamily: 'Work Sans, sans-serif' } }}>
            <FormGroup>
              <FormControlLabel
                control={<Checkbox checked={additionalChecked} onChange={handleAdditionalOptionChange} inputProps={{ 'aria-label': 'controlled' }} />}
                label={<Typography sx={{ fontFamily: 'Work Sans, sans-serif', fontSize: '15px' }}>{props.additionalOption?.title}</Typography>}
              />
            </FormGroup>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
